module.exports = __webpack_public_path__ + "img/DE00817.edca214d.png";